let igLightboxImages = document.querySelectorAll('[data-fslightbox="gallery"]');
if (igLightboxImages.length === 0) {
    igLightboxImages = document.querySelectorAll(".lightbox");
}

if (igLightboxImages.length > 0) {
    const config = typeof IgLightboxConfig !== "undefined" ? IgLightboxConfig : {};

    document.addEventListener('click', async (e) => {
        const anchor = e.target.closest('a.lightbox, a[data-fslightbox="gallery"]');
        if (anchor) {
            e.preventDefault();
            if (!window.igLightboxInstance) {
                try {
                    const modulePath = '@internetgalerie/ig-lightbox/IgLightbox.js';
                    const { IgLightbox: LightboxClass } = await import(modulePath);
                    window.igLightboxInstance = new LightboxClass({
                        sources: igLightboxImages,
                        ...config
                    });
                } catch (err) {
                    console.error("Failed to lazy-load IgLightbox:", err);
                    return;
                }
            }
            const imagesArr = Array.from(igLightboxImages);
            const index = imagesArr.indexOf(anchor);
            if (index !== -1) {
                window.igLightboxInstance._handleImageClick(e, index, anchor);
            }
        }
    });
}